let feedbackDomain = "https://feedback.foodiepenguin.com";
// only when you want to access your app on mobile on local network set domain to - http://192.168.0.158:5000
// else leave above domain variable to emprty string/
// let domain = "<enter manual domain here>"

module.exports = feedbackDomain;
